import { DesignerPickerItemResource } from 'dy-frontend-http-repository/lib/modules/TaskSubTicket/resources';

export const designerFullName = (item: DesignerPickerItemResource) =>
    `${item.user.first_name} ${item.user.last_name}`.trim();

// Typing narrows by first name, last name or the two together, so "ana", "designer" and
// "ana des" all find Ana Designer.
//
// An empty query matches everything rather than nothing: opening the field has to show the
// whole roster, because a picker that starts empty reads as a picker with nobody in it.
//
// The query is trimmed and lowercased on both sides, so a stray space or a capital never hides
// a designer who is plainly there — the most common way a search field is reported broken.
export const matchesDesignerQuery = (item: DesignerPickerItemResource, query: string): boolean => {
    const normalizedQuery = query.trim().toLowerCase();
    if (normalizedQuery.length === 0) {
        return true;
    }

    const firstName = item.user.first_name.toLowerCase();
    const lastName = item.user.last_name.toLowerCase();
    const fullName = designerFullName(item).toLowerCase();

    return (
        firstName.includes(normalizedQuery) ||
        lastName.includes(normalizedQuery) ||
        fullName.includes(normalizedQuery)
    );
};
